var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoundTripIcon = function SvgRoundTripIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exchange",
    width: 19.492,
    height: 21.24,
    viewBox: "0 0 19.492 21.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M18.605,4.429H3.024L5.942,1.512A.886.886,0,0,0,4.689.259L.259,4.689a.886.886,0,0,0,0,1.253l4.43,4.43A.886.886,0,1,0,5.942,9.119L3.024,6.2H18.605a.886.886,0,1,0,0-1.772Z",
    transform: "translate(0 0.001)",
    fill: "#00ddff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M14.8,150.26a.886.886,0,0,0-1.253,1.253l2.918,2.918H.886a.886.886,0,1,0,0,1.772H16.467l-2.917,2.917a.886.886,0,1,0,1.253,1.253l4.43-4.43a.886.886,0,0,0,0-1.253Z",
    transform: "translate(0 -139.392)",
    fill: "#00ddff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoundTripIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roundTripIcon.2f599bbf.svg";
export { ForwardRef as ReactComponent };